import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import Loadable from '../../../components/common/loadable';
import { UsageStats } from '../../../components/recordings/UsageStats';
import { useSchoolInfo } from '../../../hooks/useSchoolInfo';
import AdminAuthContainer from '../AdminAuthContainer';
import AdminSettingsContainer from '../AdminSettingsContainer';
import StyledFormTitle from '../styles/form-title';

const RecordingsTab = () => {
    const { data: schoolInfo } = useSchoolInfo();
    const schoolUuid = schoolInfo?.uuid as string;

    const { t } = useTranslation('admin_settings');
    const { isSuperAdmin } = useContainer(AdminAuthContainer);
    const { usageStats, isLoadingRecordingUsage } = useContainer(AdminSettingsContainer);

    if (!schoolUuid) {
        return null;
    }

    const showUsageStats = usageStats && (usageStats.quotaSize > 0 || isSuperAdmin);

    return (
        <>
            <StyledFormTitle>{t('recordings.title')}</StyledFormTitle>
            <Loadable fullScreen={false} isLoading={isLoadingRecordingUsage}>
                {showUsageStats ? (
                    <UsageStats
                        isLoading={isLoadingRecordingUsage}
                        totalRecordings={usageStats.totalRecordings}
                        totalSize={usageStats.totalSize}
                        quota={usageStats.quotaSize}
                    />
                ) : (
                    usageStats && <Alert severity="warning">{t('recordings.quotaNotSet')}</Alert>
                )}
            </Loadable>
        </>
    );
};

export default RecordingsTab;
